import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { normalizeCareerRolesCollection } from 'bundles/unified-common/hooks/useCareerRolesCollection';
import CareerRolesCollectionQuery from 'bundles/unified-common/queries/CareerRolesCollection.graphql';
import type {
  CareerRolesCollectionQueryQueryVariables,
  CareerRolesCollectionQueryQuery as CareerRolesCollectionQueryType,
} from 'bundles/unified-common/queries/__generated__/CareerRolesCollection';

const RECOMMENDER_CONFIGURATION_ID = 'related-roles';

function useRelatedCareerRoles({
  ssr,
  skip,
  limit = 4,
  slug,
}: {
  ssr: boolean;
  skip?: boolean;
  limit?: number;
  slug?: string;
}) {
  const { data, loading } = useQuery<CareerRolesCollectionQueryType, CareerRolesCollectionQueryQueryVariables>(
    CareerRolesCollectionQuery,
    {
      variables: {
        queryCollectionId: RECOMMENDER_CONFIGURATION_ID,
        additionalInput: {
          role_slug: slug,
        },
        limit,
      },
      notifyOnNetworkStatusChange: true,
      ssr,
      skip: skip || !slug,
      errorPolicy: 'all' as const,
      context: { clientName: 'gatewayGql' },
      onError: (error) =>
        Sentry.captureException(error, {
          extra: {
            message: `Error fetching related Pathway career roles collection with the recommender ID "${RECOMMENDER_CONFIGURATION_ID}"`,
          },
        }),
    }
  );

  return {
    data: normalizeCareerRolesCollection(data?.Collection?.queryCollection),
    loading,
  };
}

export default useRelatedCareerRoles;
